import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from "../../environments/environment"

@Injectable({
  providedIn: 'root'
})
export class ActiveQuotesService {
  constructor(private httpService: HttpClient) { }
  public getActiveQuotes(){
    let url = environment.apiUrl + "getactivequotes";
    return this.httpService.get(url);
    // return this.httpService.get('/getactivequotes');
  }
  public getFacilities(quoteNumber){
    let url = environment.apiUrl + `get-facilities/${quoteNumber}`;
    return this.httpService.get(url);
    // return this.httpService.get(`/get-facilities/${quoteNumber}`);
  }

  public getFacilityTerms(quoteNumber, term?: number){
    let url = environment.apiUrl + `get-extract-quote-term-meter/${quoteNumber}/${term}`;
    return this.httpService.get(url);
    // return this.httpService.get(`/get-facilities/${quoteNumber}`);
  }

  public getQuoteByFacilityNumber(facilityNumber){
    let url = environment.apiUrl + `get-facility-quote-number-reference/${facilityNumber}`;
    return this.httpService.get(url);
    // return this.httpService.get(`/get-facility-quote-number-reference/${facilityNumber}`);
  }

  public saveChangeRequest(body){
    let url = environment.apiUrl + 'save-change-request';
    return this.httpService.post(url, body);
    // return this.httpService.get(`/get-facility-quote-number-reference/${facilityNumber}`);
  }

  public addQuoteToFavorite(body){
    let url = environment.apiUrl + 'post-reference-flag-items';
    return this.httpService.put(url, body);
    // return this.httpService.get(`/get-facility-quote-number-reference/${facilityNumber}`);
  }

  public getFavoriteQuotes(){
    let url = environment.apiUrl + 'get-reference-flag-items';
    return this.httpService.get(url);
    // return this.httpService.get(`/get-facility-quote-number-reference/${facilityNumber}`);
  }

  public saveOpportunityName({quoteId, opportunityName}){
    let url = environment.apiUrl + `putquoteopportunityname/${quoteId}/${opportunityName}`;
    return this.httpService.put(url, {});
    // return this.httpService.get(`/get-facility-quote-number-reference/${facilityNumber}`);
  }
  public downloadContract(payload, quoteId){
    let url = environment.apiUrl + `quote-contract-gen/${quoteId}`;
    return this.httpService.post(url, payload, {responseType: "blob"});
    // return this.httpService.get(`/get-facility-quote-number-reference/${facilityNumber}`);
  }
}
